import { render, staticRenderFns } from "./ActivityList.vue?vue&type=template&id=35c8b3ee&scoped=true&"
import script from "./ActivityList.vue?vue&type=script&lang=js&"
export * from "./ActivityList.vue?vue&type=script&lang=js&"
import style0 from "./ActivityList.vue?vue&type=style&index=0&id=35c8b3ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c8b3ee",
  null
  
)

export default component.exports